// import styles from "./Secret.module.scss";
import { useContext } from "react";
import { AuthContext } from "../../services/Auth";

function Sgr() {
  const { user } = useContext(AuthContext);
  if (!user) return "Carregando...";

  return (
    <>
      <h1>SGR</h1>
      Olá {user.nome}. Seja bem vindo ao Sistema de Gestão de Alunos!
    </>
  );
}

export default Sgr;
